import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'article' | 'li';
}

export function Card({ children, className, as: Tag = 'div' }: CardProps) {
  return (
    <Tag
      className={cn(
        'rounded-(--radius-card) border border-border bg-card text-card-foreground',
        'p-5 sm:p-6',
        className,
      )}
    >
      {children}
    </Tag>
  );
}
